import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/recyclers/RecyclersComponent.tsx");
